/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsDefinizioneProdotto
 * @restrict E
 * @description Componente che gestisce le configurazione Soglie del'Approvvigionamento Telepass
 */
(function() {
  'use strict';
  var PresaInCaricoCtrl = function(
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    propostaTelepassSrvc,
    userSrvc,
    uiGridConstants,
    presaInCaricoSrvc
    // propostaDefinizioneSrvc
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    this.userSrvc = userSrvc;
    $scope.msg = labelSrvc.getLabel;
    this.uiGridConstants = uiGridConstants;
    this.presaInCaricoSrvc = presaInCaricoSrvc;

    this.propostaTelepassSrvc = propostaTelepassSrvc;
    // this.propostaDefinizioneSrvc = propostaDefinizioneSrvc;

    // Spinner
    this.spinner = this.propostaTelepassSrvc.spinner;

    this.gridOptions = {};

    this.stiliTabella = {
      height: '0px',
      width: '0px'
    };

    this.tableHeight = 0;
    this.tableWidth = 0;

    this.templatePresaInCarico = null;

    this.ricerca = {
      stato: '',
      dataDal: '',
      dataAl: ''
    };

    this.minDate = null;
    this.maxDate = null;

    this.flusso = {};

    this.gestioneApparatiFl = false;

    var self = this;

    /*
     * -------------------------------------
     *          GESTIONE INTERFACCIA
     * -------------------------------------
     */

    /*
     * -------------------------------------
     * METODI INIZIALIZZAZIONE
     * -------------------------------------
     */

    this.init = function() {
      labelSrvc.labelsPronte.then(function() {
        self.labelsPronte = true;
        // self.templatePresaInCarico = 'presaInCaricoBanca.tmpl.html';
        // self.templatePresaInCarico = 'presaInCaricoFiliale.tmpl.html';

        self.userSrvc.presaInCaricoBanca;

        if (
          self.userSrvc.presaInCaricoFiliale &&
          !self.userSrvc.presaInCaricoBanca
        ) {
          self.templatePresaInCarico = 'presaInCaricoFiliale.tmpl.html';
        } else if (
          !self.userSrvc.presaInCaricoFiliale &&
          self.userSrvc.presaInCaricoBanca
        ) {
          self.templatePresaInCarico = 'presaInCaricoBanca.tmpl.html';
        } else {
          self.templatePresaInCarico = 'presaInCaricoFiliale.tmpl.html';
        }

        // self.userSrvc.abilitazioniPronte.then(function(result) {
        //   if (!result) {
        //     self.templatePresaInCarico = 'presaInCaricoFiliale.tmpl.html';
        //     return;
        //   }
        //   if (self.userSrvc.user.ruolo !== 'DF') {
        //     self.templatePresaInCarico = 'presaInCaricoFiliale.tmpl.html';
        //   } else {
        //     self.templatePresaInCarico = 'presaInCaricoBanca.tmpl.html';
        //   }
        // });
      });
    };

    /*
     * -------------------------------------
     *        INIZIALIZZAZIONE
     * -------------------------------------
     */
    self.init();
  };

  PresaInCaricoCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsPropostaSrvc',
    'TlpsUserSrvc',
    'uiGridConstants',
    'TlpsPresaInCaricoSrvc'
    // 'TlpsDefinizioneSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsApprovvigionamento/presaInCarico/presaInCarico.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var presaInCaricoComponent = {
    bindings: {
      steps: '<',
      currentStep: '<'
    },
    controller: PresaInCaricoCtrl,
    controllerAs: 'presaInCaricoCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component('presaInCarico', presaInCaricoComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/tlpsApprovvigionamento/presaInCarico/presaInCarico.cmpt.js
// module id = 11
// module chunks = 0